<template>
  <!-- https://ithelp.ithome.com.tw/articles/10223518 -->
  <!-- $emit used when child element want to pass some data to parent element-->
  <v-navigation-drawer
    :value="isDrawerOpen"
    app
    floating
    width="260"
    class="app-navigation-menu"
    :right="$vuetify.rtl"
    @input="val => $emit('update:is-drawer-open', val)"
  >
    <!-- Navigation Header -->
    <div class="vertical-nav-header d-flex items-center ps-6 pe-5 pt-5 pb-2">
      <router-link to="/" class="d-flex align-center text-decoration-none">
        <v-slide-x-transition>
          <h2 class="app-title text--primary">
            {{ $t('general.name') }}
          </h2>
        </v-slide-x-transition>
      </router-link>
    </div>

    <!-- Navigation Items -->
    <v-list expand shaped class="vertical-nav-menu-items pr-5" v-for="link in nav_link" :key="link.title">
      <nav-menu-link :title="link.title" :to="link.name" :plural="link.plural"></nav-menu-link>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
// eslint-disable-next-line object-curly-newline
// import NavMenuSectionTitle from './components/NavMenuSectionTitle.vue'
// import NavMenuGroup from './components/NavMenuGroup.vue'
import NavMenuLink from './components/NavMenuLink.vue'

export default {
  components: {
    // NavMenuSectionTitle,
    // NavMenuGroup,
    NavMenuLink,
  },
  props: {
    isDrawerOpen: {
      type: Boolean,
      default: null,
    },
  },
  data: () => ({
    nav_link: [
      {
        title: 'navigation.home',
        name: { name: 'Home' },
        plural: false,
      },
      {
        title: 'navigation.media_coverage',
        name: { name: 'MediaCoverage' },
        plural: false,
      },
      {
        title: 'navigation.press_release',
        name: { name: 'pressRelease' },
        plural: false,
      },
      {
        title: 'navigation.jobs',
        name: { name: 'Jobs' },
        plural: true,
      },
      {
        title: 'navigation.announcement',
        name: { name: 'announcements' },
        plural: false,
      },
      {
        title: 'navigation.report',
        name: { name: 'reports' },
        plural: false,
      },
      {
        title: 'navigation.presentation',
        name: { name: 'Presentation' },
        plural: false,
      },
      {
        title: 'navigation.analyst_coverage',
        name: { name: 'AnalystCoverage' },
        plural: false,
      },
      {
        title: 'navigation.investor_notices',
        name: { name: 'InvestorRelationsNotices' },
        plural: false,
      },
      {
        title: 'navigation.enquiry',
        name: { name: 'Enquiry' },
        plural: false,
      },
    ],
  }),
}
</script>

<style lang="scss" scoped>
.app-title {
  font-size: 1.25rem;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.3px;
}

// ? Adjust this `translateX` value to keep logo in center when vertical nav menu is collapsed (Value depends on your logo)
.app-logo {
  transition: all 0.18s ease-in-out;
  .v-navigation-drawer--mini-variant & {
    transform: translateX(-4px);
  }
}

@include theme(app-navigation-menu) using ($material) {
  background-color: map-deep-get($material, 'background');
}

.app-navigation-menu {
  .v-list-item {
    &.vertical-nav-menu-link {
      ::v-deep .v-list-item__icon {
        .v-icon {
          transition: none !important;
        }
      }
    }
  }
}

// You can remove below style
// Upgrade Banner
.app-navigation-menu {
  .upgrade-banner {
    position: absolute;
    bottom: 13px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
